import { InvAdjDetail } from "./inv-adj-detail";
import { PhysicalCount } from "./physical-count";
import { ReasonCode } from "./reason-code";
import { SystemField } from "./system-field";

export class InvAdjustment extends SystemField { 
     ref_code?:string;
     external_ref_code?:string;
     adj_date?:string;
     status?:string;
     post_period?:string;
     reason_code_id?:string;
     total_qty?:number;
     total_cost?:number;
     physical_count_id?:string;

     // relationship
     langs?:any;
     details?:InvAdjDetail[];

     physical_count?:PhysicalCount;
     reason_code?:ReasonCode;
}
export class InvAdjustmentTranslate extends SystemField{ 
     lang_code?:string;
     description?:string;
     inv_adj_id?:string;
}